import { router } from "@inertiajs/react"
import { useState } from "react"

import { agentPath, setupAgentPath } from "@/routes"

// The flat slice of agent.setup_data a step persists. Constrained to
// Inertia-serialisable scalars/arrays so the PATCH body type-checks.
type SetupData = Record<string, string | number | boolean | null | string[]>

// Shared per-step persistence for the Review Responder wizard. Mirrors the
// receptionist pattern: each step PATCHes /agents/:id/setup with the next (or
// previous) step key plus its slice of setup_data, which the controller merges
// into the agent's flat setup_data. On `complete` the agent transitions
// draft -> operational server-side and we redirect to the agent dashboard.
export function useStepSave(agentUid: string) {
  const [processing, setProcessing] = useState(false)

  function save(
    setupStep: string,
    setupData: SetupData,
    opts?: {
      complete?: boolean
      onError?: (errors: Record<string, string>) => void
    },
  ) {
    setProcessing(true)
    router.patch(
      setupAgentPath({ id: agentUid }),
      {
        setup_step: setupStep,
        complete: opts?.complete ?? false,
        setup_data: setupData,
      },
      {
        preserveScroll: true,
        onError: (errors) => opts?.onError?.(errors as Record<string, string>),
        onFinish: () => setProcessing(false),
        onSuccess: () => {
          if (opts?.complete) router.visit(agentPath({ id: agentUid }))
        },
      },
    )
  }

  return { processing, save }
}
